import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import dayjs from 'dayjs'
import IdleVue from 'idle-vue'
import IdleVueComponent from 'idle-vue/src/components/Idle.vue'
import VueMask from 'v-mask'
import Vue from 'vue'
import VueTour from 'vue-tour'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import App from './App.vue'
import './plugins/acl'
import VueClarity from './plugins/clarity'
import StandardizedControlLibrary from './plugins/controllibrary'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

Vue.config.productionTip = false

// Application Insights
const appInsightsConnectionString = process.env.NODE_ENV === 'production'
  ? 'InstrumentationKey=530b4962-7417-4c22-b59f-dbbdd576d402;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=e259bdb0-8a77-44b0-ae35-0319ad4eec31'
  : 'InstrumentationKey=198a2bb1-c3ff-4561-82a0-9dab8e3bb486;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=81f8c7ce-b941-4256-95a9-725d68da30b8'
const appInsights = new ApplicationInsights({
  config: {
    connectionString: appInsightsConnectionString,
  },
})
appInsights.loadAppInsights()
appInsights.trackPageView() // Manually call trackPageView to establish the current user/session/pageview

// Vue filter(s)
Vue.filter('formatDateString', value => (value ? dayjs(value).format('MM/DD/YYYY') : null))
Vue.filter('formatDateTimeString', value => (value ? dayjs(value).format('MM/DD/YYYY h:mm:ss a') : null))

// Convert UTC to local date and format as MM/DD/YYYY
Vue.filter('formatDateStringUtcToLocal', value => {
  if (!value) return null

  return dayjs(new Date(value)).format('MM/DD/YYYY')
})

// Convert UTC to local datetime and format as MM/DD/YYYY h:mm:ss a
Vue.filter('formatDateTimeStringUtcToLocal', value => {
  if (!value) return null

  return dayjs(new Date(value)).format('MM/DD/YYYY h:mm:ss a')
})
Vue.filter('formatDollar', value => (typeof value === 'number'
  ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(value)
  : value))

// Vue Mask
Vue.use(VueMask)

// Idle view
Vue.component('idle-view', IdleVueComponent) // Required only to use idle-view component

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60000 * 1 * 60, // # 60000 * 1 * 60 = 1 minute
  startAtIdle: false,
})

// SignalR
// Vue.use(signalR)

// Mouseflow
// Vue.use(VueMouseflow, { tracking_key: 'd150ee35-0cec-4c82-ab08-f306a7356413' })

// Clarity
Vue.use(VueClarity, { projectId: pickClarityId() })

// Tawk
// Vue.use(TawkMessengerVue, { propertyId: '626ac9dfb0d10b6f3e6fd2bc', widgetId: '1g1oi94jf' })

// Vue Tour
require('vue-tour/dist/vue-tour.css')

Vue.use(VueTour)

// Standardized App Control Library
Vue.use(StandardizedControlLibrary)

// Vue directive(s)
Vue.directive('focus', {
  // When the bound element is inserted into the DOM...
  inserted(el) {
    // Focus the element
    el.focus()
  },
})

// Vue
new Vue({
  router,
  store,
  vuetify,

  mounted() {
    window.addEventListener('popstate', this.handleBackButton)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.handleBackButton)
  },
  methods: {
    handleBackButton() {
      console.log('back button pressed')

      // Check if the application is within an iframe
      if (window.self !== window.top) {
        console.log('In iFrame')

        // Inform the parent window to handle the back button action
        window.top.postMessage({ action: 'goBack' }, '*')
      } else {
        console.log('Not in iFrame')

        // Handle the back button action within the application itself
        // You can define the behavior for the back button when not within an iframe
        // For example: router.back() to navigate within the Vue application
        // router.back()
      }
    },
  },

  render: h => h(App),

  // onIdle() {
  //   console.log('User is inactive')
  // },
  // onActive() {
  //   console.log('User is active')
  // },
}).$mount('#app')

function pickClarityId() {
  const CLARITY_PROD = 't7md9zfsey'
  const CLARITY_NONPROD = 't7mgjdju6n'

  if (typeof window === 'undefined') return CLARITY_NONPROD
  const host = window.location.hostname.toLowerCase()

  if (host === 'ims.innsofcourt.org' || host === 'manage.innsofcourt.org') {
    console.log('Environment: Production')

    return CLARITY_PROD
  }

  console.log('Environment: Non-Production')

  return CLARITY_NONPROD
}
